"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfterUploadAlert = void 0;
var afterUploadAlert_1 = require("./afterUploadAlert");
Object.defineProperty(exports, "AfterUploadAlert", { enumerable: true, get: function () { return __importDefault(afterUploadAlert_1).default; } });
